import moment from 'moment';

/** Offline dropdown/container caches are refreshed once they reach this age. */
export const OFFLINE_CACHE_MAX_AGE_WEEKS = 2;

/**
 * True when an offline cache dated `cacheDate` is old enough to refetch.
 * Bug 34694: the inline check diffed the operands the wrong way round, so the
 * result was negative for any past date and a cache never expired.
 */
export function isOfflineCacheStale(
  cacheDate: number,
  now: number = Date.now()
): boolean {
  return (
    moment(now).diff(moment(cacheDate), 'weeks') >= OFFLINE_CACHE_MAX_AGE_WEEKS
  );
}

const IDLE_FALLBACK_DELAY_MS = 1000;

type IdleScheduler = (
  callback: () => void,
  options?: { timeout: number }
) => number;

/**
 * Runs `task` once the browser is idle (after the first route has rendered), so
 * background offline prefetching never competes with navigation. Falls back to a
 * short delay where requestIdleCallback is unavailable (NativeScript, older
 * Safari), which still gives the first route a head start.
 */
export function runWhenIdle(task: () => void, timeoutMs = 5000): void {
  const requestIdle = (globalThis as { requestIdleCallback?: IdleScheduler })
    .requestIdleCallback;
  if (typeof requestIdle === 'function') {
    requestIdle(() => task(), { timeout: timeoutMs });
  } else {
    setTimeout(task, IDLE_FALLBACK_DELAY_MS);
  }
}
